export default "__VITE_ASSET__CrblRoW9__"